<template>
    <div class="m-view__box">
        <pass/>
        <gift style="margin-top: 100px;"/>
    </div>
</template>

<script>
import pass from './pass.vue'
import gift from './gift.vue'

export default {
    components: {
        pass,
        gift,
    },      
}
</script>